import router from '@/router'
import store from '@/store'
import { alert as $alert } from '@/utils/alert'
import { navigateToRefresh } from '@/utils/navigation'

export default {
	state: {
		kioskOrderRemark: '',
		isCancelOrderDialog: false,
		maintenance: {
			modal: false, // 彈窗
			title: '', //標題
			message: '', //訊息
		},
		// 用於路由守衛中設置的待顯示訊息
		pendingAlert: null, // { message: string, type: 'success'|'danger'|'warning' }
		// 全域 Loading 反饋狀態
		globalLoading: {
			visible: false,
			status: 'loading', // 'loading' | 'success' | 'error'
			message: '載入中...',
			successText: '操作成功',
			errorText: '操作失敗',
			showResult: true,
			showRefreshOnError: false, // 錯誤時是否顯示重整按鈕
			resultDuration: 1500, // 結果顯示時間（毫秒）
			counter: 0, // 並發計數器
			onClose: null, // 關閉後的回調函數
		},
	},
	mutations: {
		setMaintenance($, val) {
			$.maintenance = val
		},
		setPendingAlert($, payload) {
			$.pendingAlert = payload
		},
		clearPendingAlert($) {
			$.pendingAlert = null
		},
		SHOW_GLOBAL_LOADING($, payload) {
			payload = payload || {}
			$.globalLoading.counter += 1
			$.globalLoading.visible = true
			$.globalLoading.status = 'loading'
			$.globalLoading.message = payload.message || '載入中...'
			$.globalLoading.successText = payload.successText || '操作成功'
			$.globalLoading.errorText = payload.errorText || '操作失敗'
			$.globalLoading.showResult = payload.showResult !== false
			$.globalLoading.showRefreshOnError = payload.showRefreshOnError === true
			$.globalLoading.resultDuration =
				payload.resultDuration !== undefined ? payload.resultDuration : 1500
			$.globalLoading.onClose = payload.onClose || null
		},
		SET_GLOBAL_LOADING_RESULT($, payload) {
			$.globalLoading.counter = Math.max(0, $.globalLoading.counter - 1)
			if ($.globalLoading.counter === 0) {
				$.globalLoading.status = payload.status
				if (payload.successText)
					$.globalLoading.successText = payload.successText
				if (payload.errorText) $.globalLoading.errorText = payload.errorText
			}
		},
		HIDE_GLOBAL_LOADING($) {
			$.globalLoading.visible = false
			$.globalLoading.status = 'loading'
			$.globalLoading.counter = 0
			$.globalLoading.onClose = null
		},
		UPDATE_GLOBAL_LOADING_MESSAGE($, message) {
			$.globalLoading.message = message || '載入中...'
		},
	},
	actions: {
		guidePage(ctx) {
			const random = router.history.current.params.random
			if (random) {
				if (store.state.kiosk.is || store.state.kiosk.isKioskDomain) {
					store.commit('kiosk/SET_IS', true)
					navigateToRefresh(random, { useReplace: false })
				} else {
					if (router.history.current.path !== `/${random}/Store`) {
						router.push(`/${random}/Store`)
					}
				}
				let countdown = 3
				const message = () =>
					`系統連線過期!，為保護您的資料安全，請重新刷新頁面。`

				$alert(message(), 'danger')

				const interval = setInterval(() => {
					countdown--
					if (countdown > 0) {
						$alert(`${countdown} 秒後將自動重新整理！`, 'danger')
					} else {
						clearInterval(interval)
						location.reload()
					}
				}, 1000)
			} else {
				$alert('無法識別店家，請重新掃瞄 QR code', 'danger')
				router.push('/null/Error')
			}
		},
	},
}
